// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"867":"css/nestable","870":"css/main"}[chunkId] + ".css";
};